import React from "react";
import { Modal, Button } from "react-bootstrap";

const FileViewModal = ({ show, onHide, title, fileLink }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <iframe
            src={fileLink}
            title={title}
            width="100%"
            height="700px"
            frameBorder="0"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FileViewModal;

export const PopUpModalButton = ({
  title,
  fileLink,
  variant = "primary",
  className = "",
}) => {
  const [show, setShow] = React.useState(false);
  return (
    <>
      <Button
        variant={variant}
        size="sm"
        className={className}
        onClick={(e) => {
          e.stopPropagation();
          setShow(true);
        }}
      >
        {title}
      </Button>
      <FileViewModal
        show={show}
        onHide={() => setShow(false)}
        title={title}
        fileLink={fileLink}
      />
    </>
  );
};
